/**
 * EVM Opcode constants
 */

/** JUMPDEST opcode */
export const JUMPDEST = 0x5b;

/** PUSH1 opcode */
export const PUSH1 = 0x60;

/** PUSH32 opcode */
export const PUSH32 = 0x7f;

/** STOP opcode */
export const STOP = 0x00;

/** RETURN opcode */
export const RETURN = 0xf3;

/** REVERT opcode */
export const REVERT = 0xfd;

/** INVALID opcode */
export const INVALID = 0xfe;
